import { Breadcrumb, BreadcrumbItem } from 'flowbite-react'
import React from 'react'
import { BreadcrumbData } from '@/types'
import { IoGrid } from 'react-icons/io5'

interface AppBreadcrumbProps {
  data?: BreadcrumbData[]
}

const AppBreadcrumb: React.FC<AppBreadcrumbProps> = ({ data }) => (
  <Breadcrumb>
    <IoGrid />

    {data &&
      data.map((item: BreadcrumbData, index: number) => (
        <BreadcrumbItem
          key={index}
          className={index < data.length - 1 ? 'hover:underline' : ''}
          href={item.url}
        >
          {item.name}
        </BreadcrumbItem>
      ))}
  </Breadcrumb>
)
export default AppBreadcrumb
